// @flow

import React from 'react'
import styled from 'styled-components'

import { mediaMax } from 'frontend_core/dist/styles/media'
import Colors from 'components/styles/colors'
import CardPriceIconWrapper from 'components/molecules/CardPriceIconWrapper'

const Container = styled.div`
  position: absolute;
  width: 250px;
  left: -108px;
  top: -240px;
  z-index: 1;
  ${mediaMax.desktop`
    width: 150px;
    margin-left: 60px;
    margin-top: 35px;
  `};
`
const RoomAnnotationContentLink = styled.a`
  position: relative;
  display: inline-block;
  margin-bottom: 16px;
  width: 100%;
  background-color: ${Colors.white};
  border: 1px solid ${Colors.grayD};
  border-radius: 3px;

  &::before {
    position: absolute;
    top: 100%;
    left: 50%;
    margin-left: -10px;
    content: '';
    border: 10px solid transparent;
    height: 0;
    width: 0;
    border-top-color: ${Colors.grayD};
  }

  &::after {
    position: absolute;
    margin-top: -1px;
    margin-left: -10px;
    content: '';
    top: 100%;
    left: 50%;
    border: 10px solid transparent;
    height: 0;
    width: 0;
    border-top-color: ${Colors.white};
  }
`
const Title = styled.h3`
  color: ${Colors.black};
  font-weight: bold;
  font-size: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  ${mediaMax.desktop`
    font-size: 11px;
    line-height: 1;
  `};
`
const ThumbnailWrapper = styled.div`
  position: relative;
  width: 100%;
  padding-top: 60%;
  background-image: url(${props => props.url});
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
`
const Thumbnail = styled.div`
  width: 100%;
  height: 100%;
`
const Body = styled.div`
  padding: 8px;
`
const PriceSpWrapper = styled.div`
  display: none;
  ${mediaMax.desktop`
    margin-top: 6px;
    display: table;
    table-layout: fixed;
  `};
`
const PriceSp = styled.div`
  display: table-cell;
  font-size: 13px;
`

type PropTypes = {
  name: string,
  thumbnail: string,
  price: string,
  priceUnit: string,
  isDirectReservation: boolean,
  isTopHost: boolean,
  isLastMinutesDiscount: boolean,
  roomLink: string,
}

export default (props: PropTypes) => (
  <Container>
    <RoomAnnotationContentLink href={props.roomLink} target="_blank">
      <ThumbnailWrapper url={props.thumbnail}>
        <Thumbnail />
      </ThumbnailWrapper>
      <Body>
        <Title>{props.name}</Title>
        <PriceSpWrapper>
          <PriceSp>
            {i18n.t('page.search.price', {
              price: props.price,
              unit: props.priceUnit,
            })}
          </PriceSp>
          <CardPriceIconWrapper
            isDirectReservation={props.isDirectReservation}
            isTopHost={props.isTopHost}
            isLastMinutesDiscount={props.isLastMinutesDiscount}
            size="small"
          />
        </PriceSpWrapper>
      </Body>
    </RoomAnnotationContentLink>
  </Container>
)



// WEBPACK FOOTER //
// ./src/components/molecules/SearchRoomAnnotation.jsx